export default ({vehicle: {vehicle_year = ''} = {}} = {}) => vehicle_year;
